"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("schedules").controller("SchedulesCtrl", SchedulesCtrl);

  function SchedulesCtrl($state, $rootScope, $scope, $timeout, $controller, moment, AgGridService, CustomersService, CustomListsService, UsersService, SchedulesService, OperatorsService, ModalService, DepasService) {
    var _this = this;

    var vm = this;

    vm.ctrlName = "SchedulesCtrl";

    vm.activeTab = 'planning';

    vm.log = debug("pages:schedules");

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: SchedulesService,
      params: {
        editPage: "schedules/schedule"
      }
    });

    vm.isLvr = ["super-admin", "super-operator", "operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.gridEvent = function (value) {
      console.log("gridEvent", value);
      if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      // Une feuille par grille affichée (périodes fermées, conseillers).
      var sheets = Object.keys(vm.exportSheet).map(function (index) {
        return vm.exportSheet[index]();
      });

      vm.gridApi[Object.keys(vm.gridApi)[0]].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Créneaux"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.editClosedSlot = function (row) {
      ModalService.openComponent("closed-slot", { _id: row._id, size: "lg" }).then(function () {
        vm.refresh();
      }).catch(function (err) {
        console.log(err);
      });
    };

    vm.deleteClosedSlot = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        var start, end, deleteClosedSlot;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                start = moment(row.slot.start).format("DD/MM/YYYY à HH:mm");
                end = moment(row.slot.end).format("DD/MM/YYYY à HH:mm");
                _context.next = 4;
                return swal({
                  title: "Voulez-vous supprimer la p\xE9riode ferm\xE9e du " + start + " au " + end + " de " + row.operatorName + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 4:
                deleteClosedSlot = _context.sent;

                if (!deleteClosedSlot) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return DepasService.deleteById(row._id);

              case 9:
                Notiflix.Notify.success("La suppression a réussi");
                vm.refresh();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);

                Notiflix.Notify.failure("La suppression a échoué");

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.refresh = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        var customers, typesOfAccidentList, index, operator, disabledCustomers, enabledCustomers, allCustomers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, customer, from, bookedSlots, bookedSlot, user, start, end, duration, days, hours, minutes;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (vm.isLvr) {
                  _context2.next = 3;
                  break;
                }

                $rootScope.$broadcast("auth_not_authorized");
                return _context2.abrupt("return");

              case 3:
                if (!($rootScope.$selectedCustomerId !== "$592e962acef2545fb62f1a99")) {
                  _context2.next = 6;
                  break;
                }

                $state.go("home");
                return _context2.abrupt("return");

              case 6:

                Notiflix.Loading.standard("Chargement...");

                // Le planning se recharge à chaque changement de ce compteur.
                $timeout(function () {
                  vm.planningReload = (vm.planningReload || 0) + 1;
                });

                _context2.next = 10;
                return CustomersService.find({
                  filter: {
                    where: {},
                    fields: {
                      _id: true,
                      name: true,
                      operatorIds: true,
                      active: true
                    }
                  }
                });

              case 10:
                customers = _context2.sent;
                _context2.next = 13;
                return CustomListsService.getSelectArray("typeOfAccidentV2");

              case 13:
                typesOfAccidentList = _context2.sent;


                vm.rawOperatorData = [];
                _context2.next = 17;
                return OperatorsService.get();

              case 17:
                vm.operators = _context2.sent;
                index = 0;

              case 19:
                if (!(index < vm.operators.length)) {
                  _context2.next = 67;
                  break;
                }

                operator = vm.operators[index];

                if (!(vm.selectOperator && vm.selectOperator.length > 0)) {
                  _context2.next = 24;
                  break;
                }

                if (!(vm.selectOperator.indexOf(operator._id) < 0)) {
                  _context2.next = 24;
                  break;
                }

                return _context2.abrupt("continue", 64);

              case 24:

                operator.activatedTypeNames = operator.activatedTypes && operator.activatedTypes.length > 0 ? operator.activatedTypes.map(function (type) {
                  return typesOfAccidentList.find(function (t) {
                    return t.value === type;
                  }).name || type;
                }).join(", ") : "Tous";

                disabledCustomers = [];
                enabledCustomers = [];
                allCustomers = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 31;
                _iterator = customers[Symbol.iterator]();

              case 33:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 42;
                  break;
                }

                customer = _step.value;

                if (customer.active) {
                  _context2.next = 37;
                  break;
                }

                return _context2.abrupt("continue", 39);

              case 37:
                allCustomers.push(customer);
                if (operator.disabledCustomersId && operator.disabledCustomersId.includes("$" + customer._id)) {
                  disabledCustomers.push(customer.name);
                } else {
                  enabledCustomers.push(customer.name);
                }

              case 39:
                _iteratorNormalCompletion = true;
                _context2.next = 33;
                break;

              case 42:
                _context2.next = 48;
                break;

              case 44:
                _context2.prev = 44;
                _context2.t0 = _context2["catch"](31);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 48:
                _context2.prev = 48;
                _context2.prev = 49;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 51:
                _context2.prev = 51;

                if (!_didIteratorError) {
                  _context2.next = 54;
                  break;
                }

                throw _iteratorError;

              case 54:
                return _context2.finish(51);

              case 55:
                return _context2.finish(48);

              case 56:

                operator.disabledCustomersNumber = disabledCustomers.length;
                operator.disabledCustomers = disabledCustomers.length ? disabledCustomers.join(", ") : "Aucun";

                operator.abledCustomersNumber = enabledCustomers.length;
                operator.enabledCustomers = enabledCustomers.length === allCustomers.length ? "Tous" : enabledCustomers.join(", ");

                operator.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };

                if (!operator.depaLimitHour || typeof operator.depaLimitHour !== "string") {
                  operator.depaLimitHour = "07:00 (par défaut)";
                }

                if (typeof operator.depaPriority !== "number") {
                  operator.depaPriority = "0 (par défaut)";
                }

                vm.rawOperatorData.push(operator);

              case 64:
                index++;
                _context2.next = 19;
                break;

              case 67:
                _context2.prev = 67;

                vm.log("refresh schedules", params);

                // Périodes fermées affichées à partir du début du mois précédent.
                from = moment().subtract(1, "months").startOf("month").toDate();
                _context2.next = 72;
                return SchedulesService.post("mobile/bookedSlots", {
                  start: from
                });

              case 72:
                bookedSlots = _context2.sent;


                vm.rawClosedSlotData = [];

                index = 0;

              case 75:
                if (!(index < bookedSlots.length)) {
                  _context2.next = 113;
                  break;
                }

                bookedSlot = bookedSlots[index];

                if (!(bookedSlot.status !== "Fermé")) {
                  _context2.next = 79;
                  break;
                }

                return _context2.abrupt("continue", 110);

              case 79:
                _context2.next = 81;
                return UsersService.getById(bookedSlot.slot.operatorId);

              case 81:
                user = _context2.sent;

                if (user) {
                  _context2.next = 87;
                  break;
                }

                vm.log("user not found", bookedSlot.slot.operatorId);
                return _context2.abrupt("continue", 110);

              case 87:
                if (!(vm.selectOperator && vm.selectOperator.length > 0)) {
                  _context2.next = 90;
                  break;
                }

                if (!(vm.selectOperator.indexOf(user._id) < 0)) {
                  _context2.next = 90;
                  break;
                }

                return _context2.abrupt("continue", 110);

              case 90:

                if (bookedSlot.slot && bookedSlot.slot.start) {
                  bookedSlot.slotStart = bookedSlot.slot.start;
                }
                if (bookedSlot.slot && bookedSlot.slot.end) {
                  bookedSlot.slotEnd = bookedSlot.slot.end;
                }

                bookedSlot.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };
                bookedSlot.btDelete = {
                  text: '<i class="fa fa-trash"></i> Suppr.',
                  color: "custom-danger"
                };

                if (!(bookedSlot.slot && bookedSlot.slot.operatorId)) {
                  _context2.next = 109;
                  break;
                }

                _context2.next = 97;
                return OperatorsService.getById(bookedSlot.slot.operatorId);

              case 97:
                bookedSlot.operator = _context2.sent;


                vm.log(bookedSlot.slot.operatorId, " operator=", bookedSlot.operator);

                _context2.next = 101;
                return OperatorsService.getNameById(bookedSlot.slot.operatorId);

              case 101:
                bookedSlot.operatorName = _context2.sent;
                start = moment(bookedSlot.slot.start);
                end = moment(bookedSlot.slot.end);
                duration = moment.duration(end.diff(start));
                // duration in days

                days = parseInt(duration.asDays());
                // duration in hours

                hours = parseInt(duration.asHours()) % 24;
                // duration in minutes

                minutes = parseInt(duration.asMinutes()) % 60;

                if (days == 0) {
                  if (hours == 0) {
                    bookedSlot.nbDays = minutes + " minute(s)";
                  } else {
                    if (minutes == 0) {
                      bookedSlot.nbDays = hours + " heure(s)";
                    } else {
                      bookedSlot.nbDays = hours + " heure(s) et " + minutes + " minute(s)";
                    }
                  }
                } else {
                  if (hours == 0) {
                    if (minutes == 0) {
                      bookedSlot.nbDays = days + " jour(s)";
                    } else {
                      bookedSlot.nbDays = days + " jour(s) et " + minutes + " minute(s)";
                    }
                  } else {
                    if (minutes == 0) {
                      bookedSlot.nbDays = days + " jour(s) et " + hours + " heure(s)";
                    } else {
                      bookedSlot.nbDays = days + " jour(s), " + hours + " heure(s) et " + minutes + " minute(s)";
                    }
                  }
                }

              case 109:
                vm.rawClosedSlotData.push(bookedSlot);

              case 110:
                index++;
                _context2.next = 75;
                break;

              case 113:

                Notiflix.Loading.remove();

                $timeout(function () {
                  _this.needToBeUpdate = true;
                });
                _context2.next = 122;
                break;

              case 117:
                _context2.prev = 117;
                _context2.t1 = _context2["catch"](67);

                Notiflix.Notify.failure("Une erreur est survenue au chargement des données");

                console.error(_context2.t1);
                Notiflix.Loading.remove();

              case 122:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[31, 44, 48, 56], [49,, 51, 55], [67, 117]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.editOperator = function (row) {
      console.log(row);
      vm.log("row=", row);
      ModalService.open("users/user", { _id: row._id }).then(function (_id) {
        vm.refresh();
      });
    };

    vm.columnDefs2 = [AgGridService.text("lastName", "Nom"), AgGridService.text("firstName", "Prénom"), AgGridService.number("depaPriority", "Priorité DEPA"), AgGridService.text("depaBookingCutoffMode", "Rendez-vous concernés", undefined, {
      valueGetter: function valueGetter(params) {
        return params.data.depaBookingCutoffMode === "next-day" ? "Demain" : "Aujourd’hui";
      }
    }), AgGridService.text("depaLimitHour", "Heure limite de prise de RDV DEPA"), AgGridService.bool("depaSlidingSlots", "Avec créneaux glissants (1 heure)", false, {
      className: "col-xs-12 col-sm-3"
    }), AgGridService.number("disabledCustomersNumber", "Nombre de clients désactivés"), AgGridService.number("disabledCustomers", "Clients désactivés"), AgGridService.text("activatedTypeNames", "Types de sinistre activés"), AgGridService.number("abledCustomersNumber", "Nombre de clients activés"), AgGridService.number("enabledCustomers", "Clients activés")];

    vm.columnDefs3 = [AgGridService.text("operatorName", "Conseiller/ère", 110), AgGridService.date("slotStart", "Début (date)", 100), AgGridService.hour("slotStart", "Début (heure)", 85), AgGridService.date("slotEnd", "Fin (jour)", 100), AgGridService.hour("slotEnd", "Fin (heure)", 85), AgGridService.text("nbDays", "Durée", 85), AgGridService.text("note", "Description", 85)];

    if (vm.isSuper) {
      vm.columnDefs2.unshift(AgGridService.group("Actions", [AgGridService.button("btEdit", "Modifier", vm.editOperator, this, {
        width: 90
      })]));
    }

    if (vm.isSuper) {
      vm.columnDefs3.unshift(AgGridService.group("Actions", [AgGridService.button("btEdit", "Modifier", vm.editClosedSlot, this, {
        width: 90
      }), AgGridService.button("btDelete", "Suppr.", vm.deleteClosedSlot, this, {
        width: 90,
        columnGroupShow: "open"
      })]));
    }

    vm.refresh();
  }
})();